import React from "react";
import { useLocation } from "react-router";
import { gql, useQuery } from "@apollo/client";
import { toast } from "react-toastify";

import { ReportFullPage as AllFSCIFullPage } from "src/pages/reports/fsci/all/report_full_page";
import { ReportFullPage as AllFFIFullPage } from "src/pages/reports/ffi/all/report_full_page";

export const GET_REPORTS_QUERY = gql`
    query GetReport($searchType: String!) {
        viewer {
            user {
                id
                school {
                    id
                    name
                    reports(where: { results: { exists: true }, type: { equalTo: $searchType } }, order: [year_DESC]) {
                        count
                        edges {
                            node {
                                id
                                year
                                version
                                type
                                results
                                constituentGroups
                                surveysCompleted
                            }
                        }
                    }
                }
            }
        }
    }
`;

/*
 * Main
 */

function parseString(str: string) {
    const matches = str.match(/\/reports\/(\w+)\/(print)/);
    if (matches && matches.length === 3) {
        const type = matches[1];
        return { type };
    } else {
        return { type: "" };
    }
}

export const ReportsFullPage = (): React.ReactElement => {
    const state = useLocation();
    const { type } = parseString(state.pathname);

    const { data, error, loading } = useQuery(GET_REPORTS_QUERY, {
        variables: {
            searchType: type,
        },
    });

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        toast.error("Error loading report");
    }

    const school = data.viewer.user.school;
    const reports = data.viewer.user.school.reports.edges.filter(
        (edge: { node: { results: Record<string, unknown> } }) =>
            edge.node.results && Object.keys(edge.node.results).length > 0,
    );

    return (
        <div>
            {type === "fsci" && <AllFSCIFullPage reports={reports} school={school} />}
            {type === "ffi" && <AllFFIFullPage reports={reports} school={school} />}
        </div>
    );
};
